module.exports = __webpack_public_path__ + "assets/img/d37ff06665b9016b7f8aaeb0370a2ed9.png";